import * as React from 'react';

function SvgNoAvatarPlus(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 49 47" {...props}>
    <circle cx={23} cy={23} r={23} fill="#fff" />
    <path
      fill="#007BFF"
      d="M27.189 20.972c1.585-1.23 2.604-3.133 2.604-5.259C29.793 12.021 26.736 9 23 9s-6.792 3.021-6.792 6.713c0 2.126 1.018 4.028 2.603 5.259C14.283 22.65 11 27.014 11 32.049c0 6.601 24 6.601 24 0 0-5.035-3.17-9.399-7.811-11.077"
    />
    <circle cx={39} cy={37} r={10} fill="#0C3998" />
    <path stroke="#fff" strokeLinecap="round" strokeWidth={2} d="m39 33 .085 8M35 37l8 .085" />
  </svg>)
}
export default SvgNoAvatarPlus;
